/**
 * ESocialStatusBar Component
 * Compact horizontal bar showing eSocial event statistics as chips
 */

import React from 'react';
import { Box, Chip, Skeleton } from '@mui/material';
import { ESocialDashboard } from '../../../../types/esocial';

interface ESocialStatusBarProps {
  dashboard: ESocialDashboard | null;
  loading?: boolean;
}

const statConfig = [
  { key: 'total', label: 'Total', color: 'primary' as const },
  { key: 'draft', label: 'Rascunhos', color: 'default' as const },
  { key: 'pending', label: 'Pendentes', color: 'warning' as const },
  { key: 'authorized', label: 'Autorizados', color: 'success' as const },
  { key: 'rejected', label: 'Rejeitados', color: 'error' as const },
  { key: 'error', label: 'Erros', color: 'error' as const },
  { key: 'submitted', label: 'Transmitidos', color: 'info' as const },
  { key: 'cancelled', label: 'Cancelados', color: 'default' as const },
] as const;

const ESocialStatusBar: React.FC<ESocialStatusBarProps> = ({
  dashboard,
  loading = false,
}) => {
  if (loading) {
    return (
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {Array.from({ length: 4 }).map((_, i) => (
          <Skeleton key={i} variant="rounded" width={80} height={24} />
        ))}
      </Box>
    );
  }

  const stats = dashboard?.stats;

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
      {statConfig.map(({ key, label, color }) => {
        const value = stats?.[key] ?? 0;
        return (
          <Chip
            key={key}
            variant="outlined"
            size="small"
            color={color}
            label={`${label}: ${value}`}
            sx={value === 0 ? { opacity: 0.5 } : undefined}
          />
        );
      })}
    </Box>
  );
};

export default ESocialStatusBar;
